var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.oW=require("crc-32");module.exports=$CLJS.oW;